import { IGetCreativesDataFormatted, IGetOffersDataFormatted } from '@api/types';

export interface IOffers {
    value: number;
    label: string;
}

export interface IOptions {
    value: string;
    key: string;
}

export interface IFilters {
    offerId: string;
    search: string;
    inputSearch: string;
}

export interface IPreparedCreativesData {
    creativeSrc: IGetCreativesDataFormatted;
    placementByOfferIdStatus?: PlacementByOfferIdStatus;
    offer?: IGetOffersDataFormatted;
    placementUrl: string;
}

export type PlacementByOfferIdStatus = 'allow' | 'waiting' | 'review' | undefined;
export enum PlacementByOfferIdStatusEnum {
    ALLOW = 'allow',
    WAITING = 'waiting',
    REVIEW = 'review',
}
